import { render, staticRenderFns } from "./PlaceTable.vue?vue&type=template&id=00e6978e"
import script from "./PlaceTable.vue?vue&type=script&lang=js"
export * from "./PlaceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports